<script>
    import { getContext } from 'svelte'
    import Gallery from 'svelte-gallery'
    import GalleryImage from './GalleryImage.svelte'
    import { IMAGE_SIZES as SIZES } from '../../models'

    export let images = []
    
    const { open: openPhotoswipe } = getContext('photoswipe')

    let windowWidth

    $: galleryImages = images.map(image => {
        const size = image.getSize(SIZES.MD)
        
        return {
            src: size.src,
            width: size.width,
            height: size.height,
            alt: image.alt,
            onClick: () => openPhotoswipe(images, image)
        }
    })

    // TODO: consider using rems instead?
    $: rowHeight = windowWidth / 4
</script>

<svelte:window bind:outerWidth={windowWidth} />
<Gallery images={galleryImages} imageComponent={GalleryImage} {rowHeight} />
